import { render } from "./ContactRoute.vue?vue&type=template&id=70f3bee0"
import script from "./ContactRoute.vue?vue&type=script&lang=js"
export * from "./ContactRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__